export default __webpack_public_path__ + "static/media/coracaoMenu.95fe1942.svg";